"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSlice = authSlice;
const authInitialState = {
    auth: {
        login: {
            isPasswordLogin: true,
            isSSOLogin: false,
        },
    },
};
function authSlice(set) {
    return {
        ...authInitialState,
        setLoginMethod({ isPasswordLogin = false, isSSOLogin = false }) {
            set((state) => {
                state.auth.login.isPasswordLogin = isPasswordLogin;
                state.auth.login.isSSOLogin = isSSOLogin;
                return state;
            }, false, '[setLoginMethod]');
        },
    };
}
